import { Component } from 'react'

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { authContext } from "../../context/AuthContext";

class IdleDialog extends Component {
    static contextType = authContext;
//function IdleDialog(props) {

    onLogout = (event) => {
        console.log('from idle box', this.context);
        console.log("contextType", this.contextType)
        let saml = this.context.logout();
        if (saml) {
            this.props.history.replace('/logoutSAML');

        }

            this.props.onLogout()
    }



 render () {

    // if(this.props.open){
    //     setTimeout(this.onLogout, 20000)
    // }
    

    return (
        <Dialog
            open={this.props.open}
            onClose={this.props.onStay}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title">{"Session Time Out"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    You Will Get Timed Out. Do you want to stay on this page?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.props.onStay} variant="outlined" >
                    Stay
                </Button>
                <Button onClick={this.onLogout} variant="contained" className={[].join(' ')}>
                    Logout
                </Button>
                
            </DialogActions>
        </Dialog>
    )
}
}

  export default (IdleDialog);